import { useTranslation } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../assets/css/slider.css";

import sliders from "../assets/data/slider.json";

const Slider = () => {
    const { t } = useTranslation();
    const { slides, settings } = sliders;

    return (
        <div className="slider" id="slider">
            <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                loop={settings.loop ?? true}
                autoplay={
                    settings.autoplay ?
                        {
                            delay: settings.autoplaySpeed ?? 3000,
                            disableOnInteraction: false,
                        }
                    :   false
                }
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                speed={settings.speed ?? 500}
                slidesPerView={1}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="slide">
                            <img
                                src={slide.image}
                                alt={t("slider.bannerAlt", {
                                    index: index + 1,
                                })}
                                className="slide-image slide-zoom"
                            />

                            <div className="slide-content">
                                <p>{t(slide.titleKey)}</p>
                                <h1>{t(slide.descriptionKey)}</h1>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default Slider;
